import { useState, useEffect } from 'react';
import { useGetCentralOrganismsQuery } from '../../../../services/organismsApi';
import { useOrganizationFilter } from '../../../../contexts/OrganizationFilterContext';

interface Contract {
    id: number;
    nombre: string;
    nroContrato: number;
}

// `organizationIdOverride` permite a un formulario con su propio filtro de cliente (p.ej. Alta
// de Visitas) filtrar los contratos por ese cliente en vez del filtro global de organización.
// Si no se pasa (undefined), se usa el filtro global como hasta ahora.
// `skip` evita la consulta (p.ej. mientras un formulario no tiene cliente elegido). Es opcional:
// sin él, el comportamiento no cambia.
const useContracts = (
    organizationIdOverride?: number | null,
    { skip = false }: { skip?: boolean } = {}
) => {
    const { selectedOrganization } = useOrganizationFilter();
    const selectedOrganizationId =
        organizationIdOverride !== undefined
            ? organizationIdOverride
            : typeof selectedOrganization === 'object'
                ? selectedOrganization?.id
                : selectedOrganization;
    const { data, error, isLoading, isFetching } = useGetCentralOrganismsQuery(
        { idOrganizacion: selectedOrganizationId },
        { skip }
    );
    const [contracts, setContracts] = useState<Contract[]>([]);

    useEffect(() => {        

        if (data && data.data && data.data.organismosCentral) {
            const formattedContracts = data.data.organismosCentral.map((item: any) => ({
                id: item.id,
                nombre: item.nombre,
                nroContrato: item.nroContrato
            }));

            setContracts(formattedContracts);
        }
    }, [data]);

    return {
        contracts,
        loading: isLoading,
        isFetching,
        error,
        rawContracts: data?.data?.organismosCentral || []
    };
};

export default useContracts;
